import type { Move } from '../../move/move';
import type { PokemonV2 } from '../../pokemon/pokemon';
import type { damageRateMapper } from '../../types/damage';
import type { otherSetting } from '../../OtherSetting';
import { calcDefenceEffectiveValueCached } from './effective-cache';

// 防御側ダミー情報を反映したコピーを作成し、実値をキャッシュ計算
export function copiedDummyInfoForDefencePokemon({
  deffencePokemon,
  deffenceDummyPokemon,
}: {
  deffencePokemon: PokemonV2;
  deffenceDummyPokemon: PokemonV2;
}): PokemonV2 {
  const newDefencePokemon = { ...deffencePokemon };
  newDefencePokemon.effective_slider_step = deffenceDummyPokemon.effective_slider_step;
  newDefencePokemon.personality = deffenceDummyPokemon.personality;
  newDefencePokemon.selected_item_id = deffenceDummyPokemon.selected_item_id;
  newDefencePokemon.individualValue = deffenceDummyPokemon.individualValue;
  newDefencePokemon.terasu_type = deffenceDummyPokemon.terasu_type;
  newDefencePokemon.effective_value = calcDefenceEffectiveValueCached(newDefencePokemon);
  return newDefencePokemon;
}

export function computeWithRand(
  calcFn: (args: {
    move: Move;
    offencePokemon: PokemonV2;
    deffencePokemon: PokemonV2;
    rateMapper: damageRateMapper;
    loopHitNumber: number;
    otherSetting: otherSetting;
    isCritical?: boolean;
    attackMode?: boolean;
  }) => number,
  args: {
    move: Move;
    offencePokemon: PokemonV2;
    deffencePokemon: PokemonV2;
    rateMapper: damageRateMapper;
    loopHitNumber: number;
    otherSetting: otherSetting;
    isCritical?: boolean;
    attackMode?: boolean;
  }
): number[] {
  const retList: number[] = [];
  // ダメージ乱数（0.85〜1.00）を0.01刻みで評価する
  for (let rand = 0.85; rand <= 1.0; rand += 0.01) {
    const newRate: damageRateMapper = { ...args.rateMapper, randRate: rand };
    const base = calcFn({ ...args, rateMapper: newRate });
    retList.push(base);
  }
  return retList;
}

// ランク補正を実数値へ反映（攻撃/防御/特攻/特防などに共通使用）
export function calcRankedValue(baseValue: number, rate: number): number {
  let ratio = 2 / 2;
  if (rate > 0) {
    ratio = (2 + rate) / 2;
  } else if (rate < 0) {
    ratio = 2 / (2 + Math.abs(rate));
  }
  return Math.floor(baseValue * ratio);
}

// 「五捨五超入」（0.5 を切り捨て、それより大きい端数は切り上げ）
export function calc_五捨五超入_gosutegoire(a: number): number {
  return Math.ceil(a - 0.5);
}
